module.exports = __webpack_public_path__ + "static/media/besins-logo.29cb87f0.svg";